import BaseService from '@/services/BaseService'
import { http } from './config'
class EtiquetaService extends BaseService {
    constructor(){
        super('/v1/etiquetas')
    }
    atualizar(data){
        const id = data.get('id')
        return http.post(`/v1/etiquetas/${id}`, data)
    }
    imprimir(data){
        return http.post('/v1/etiquetas-imprimir', data)
    }
}

export default new EtiquetaService